import { useCallback, useState } from 'react';
import { configs } from '@constants/configs/configs';
import { axiosApi } from '@services/axiosInstance';

/**
 * Fetches a member's name-change history (newest first) for the Account Activity
 * member-name header hover. Backed by the read-only name-history endpoint
 * (Envers audit data).
 */
export interface IMemberNameHistoryEntry {
    firstName: string;
    lastName: string;
    effectiveDate: string;
}

export default function useMemberNameHistory() {
    const [nameHistory, setNameHistory] = useState<IMemberNameHistoryEntry[]>([]);

    const fetchNameHistory = useCallback(async (encHouseholdId: string) => {
        if (!encHouseholdId) {
            return;
        }
        try {
            const res = await axiosApi.get(`${configs.endpoints.MEMBER_NAME_HISTORY}${encHouseholdId}`);
            const data = res?.data?.data;
            setNameHistory(Array.isArray(data) ? data : []);
        } catch (e) {
            // Non-fatal: header simply renders without the history tooltip.
            setNameHistory([]);
        }
    }, []);

    return { nameHistory, fetchNameHistory };
}
